<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="relative">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <div class="text__view flex flex-col justify-center text-center mb-5">
        <h1 class="font-semibold text-2xl my-5">
          Cognitive principles that affect your marketing
        </h1>
        <p class="leading-6 max-w-5xl mx-auto">
          These biases exist in humans inherently and they can influence a
          consumer's rational and his or her reasoning ability. So let’s have a
          look at the cognitive biases that will make your marketing strategy
          more effective.
        </p>
      </div>

      <div class="tips__wrapper py-10 justify-items-center lg:py-10 w-full">
        <div
          @click="selectCategory('product')"
          class="cursor-pointer rounded-lg w-full h-20 flex items-center justify-center  bg-blue-100 duration-500"
          :class="{
            'bg-indigo-600': product,
            'text-white': product,
            'text-gray-500': !product,
          }"
        >
          <h1 class="text-3xl font-semibold">Product</h1>
        </div>
        <div v-if="product" class=" bg-gray-100 w-full h-100 border rounded-md">
          <TableTip :info="product_info" />
        </div>
        <div
          @click="selectCategory('price')"
          class="cursor-pointer rounded-lg w-full h-20 flex items-center justify-center bg-gray-200 duration-500"
          :class="{
            'bg-indigo-600': price,
            'text-white': price,
            'text-gray-500': !price,
          }"
        >
          <h1 class="text-3xl font-semibold">Price</h1>
        </div>
        <div v-if="price" class="bg-gray-100 w-full h-100 border rounded-md">
          <TableTip :info="price_info" />
        </div>
        <div
          @click="selectCategory('place')"
          class="cursor-pointer rounded-lg w-full h-20 flex items-center justify-center bg-blue-100 duration-500"
          :class="{
            'bg-indigo-600': place,
            'text-white': place,
            'text-gray-500': !place,
          }"
        >
          <h1 class="text-3xl font-semibold">Place</h1>
        </div>
        <div v-if="place" class="bg-gray-100 w-full h-100 border rounded-md">
          <TableTip :info="place_info" />
        </div>
        <div
          @click="selectCategory('promotion')"
          class="cursor-pointer rounded-lg w-full h-20 flex items-center justify-center bg-gray-100 duration-500"
          :class="{
            'bg-indigo-600': promotion,
            'text-white': promotion,
            'text-gray-500': !promotion,
          }"
        >
          <h1 class="text-3xl font-semibold">Promotion</h1>
        </div>
        <div
          v-if="promotion"
          class="bg-gray-100 w-full h-100 border rounded-md"
        >
          <TableTip :info="promotion_info" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Icon from "@/components/UI/Icon";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import TableTip from "@/components/UI/TableTip";
import { useRouter } from "vue-router";
export default {
  components: { HeaderApp, AdblockTopbar, TableTip },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });

    const product = ref(false);
    const price = ref(false);
    const promotion = ref(false);
    const place = ref(false);
    const price_info = computed(() => {
      return [
        ["Quantity discounts", "Consumption impulses"],
        ["Reference prices", "Price sensitivity", "Price-quality heuristic"],
        ["Pay What You Want", "Charitable giving", "Price fairness"],
        ["Tariff choicen"],
        ["Usage prediction", "Habit formation"],
        ["Store image"],
        ["Price presentation", "Price promotion", "Partitioned prices"],
        ["Price knowledge"],
        [],
        ["Bidding behavior"],
      ];
    });
    const product_info = computed(() => {
      return [
        ["Utilitarian vs. hedonic product choice", "Durable product adoption"],
        [
          "Extended warranties",
          "Product insurance",
          "Endowment effect",
          "Return policy",
        ],
        ["Fair trade labeling"],
        ["New product adoption"],
        ["Remote purchases", "Durable goods purchases"],
        ["Investment decisions"],
        [
          "Package labelling",
          "Delivery option",
          "Local choice context",
          "Preference for 'all average'",
          "Producto line design",
        ],
        [
          "Information overload",
          "Consideration/choice set construction",
          "Inattention to attributes",
          "Left-digit bias",
        ],
        ["Peer efects"],
        ["Branding"],
      ];
    });
    const place_info = computed(() => {
      return [
        ["Impulse buying"],
        ["Endowment effect", "Need for touch"],
        [],
        ["Online search"],
        [],
        [],
        [
          "In-store marketing",
          "Store layout",
          "Recommendations",
          "Search cost",
          "Ranking effects",
          "Channel effects",
        ],
        [],
        ["Social influence"],
        [],
      ];
    });
    const promotion_info = computed(() => {
      return [
        ["Sweepstakes and lotteries", "Hedonic consumption"],
        [
          "Probabilistic rewards",
          "Frequency (loyalty) programs",
          "Reward structure of sweepstakes",
        ],
        ["Charitable giving", "Direct marketing", "Sales force incentives"],
        ["Probabilistic promotion", "Delayed promotion", "Redemption slippage"],
        [],
        ["Casino gambling"],
        ["Redemption rates", "Comparative advertising"],
        ["Feature advertisement"],
        ["Exaggerated claims", "Anecdotal claims"],
        [],
      ];
    });
    const backToInitial = () => {
      router.push("/Psychology");
    };
    const selectedCategory = ref({});
    const selectCategory = (value) => {
      if (value === "promotion") {
        promotion.value = !promotion.value;
        place.value = false;
        product.value = false;
        price.value = false;
      } else if (value === "price") {
        price.value = !price.value;
        promotion.value = false;
        place.value = false;
        product.value = false;
      } else if (value === "place") {
        place.value = !place.value;
        promotion.value = false;
        product.value = false;
        price.value = false;
      } else {
        product.value = !product.value;
        promotion.value = false;
        place.value = false;
        price.value = false;
      }
    };
    const roleUser = computed(() => store.state.role);

    return {
      product_info,
      price_info,
      place_info,
      promotion_info,
      roleUser,
      selectedCategory,
      selectCategory,
      backToInitial,
      product,
      price,
      promotion,
      place,
    };
  },
};
</script>

<style scoped>
.tips__wrapper {
  @apply grid;
}
.table__grid {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}
.button__tips {
  border-radius: 20px;
}
.button__tips-text::before {
  display: block;
  content: " ";
  height: 3px;
  width: 20%;
  position: absolute;
  left: 40%;
  top: -15px;
  margin-bottom: 10px;
  margin-right: 10px;
  @apply bg-indigo-600;
}
</style>
